module.exports = __webpack_public_path__ + "img/UltrackDriver.fa8136d0.jpg";